import React, { useMemo, useState } from "react";
import "../styles/CasosExito.scss";

const CASES = [
  {
    name: "Mariana López",
    role: "Servicios en línea",
    text:
      "Pasó de “publicar sin rumbo” a una estrategia completa: contenido constante, campañas optimizadas y un bot en Messenger para responder 24/7. Con landing para convertir y automatizaciones para dar seguimiento, hoy recibe prospectos diarios con un proceso más ordenado y profesional.",
    featured: true,
  },
  {
    name: "Carlos Ramírez",
    role: "Cadena de gimnasios",
    text:
      "Implementamos un sistema integral: campañas por zona, contenido que genera confianza, landing por promoción y chatbot para agendar. Además, automatizamos el seguimiento de leads para que el equipo se enfoque en cerrar. Resultado: más mensajes, más citas y mejor control del embudo.",
  },
  {
    name: "Andrea Torres",
    role: "Proveedora del sector construcción",
    text:
      "Profesionalizamos su presencia digital con página/landing enfocada en cotizaciones, contenido para posicionar el negocio y campañas para captar proyectos. Sumamos bot en Messenger para responder preguntas frecuentes y automatizaciones para organizar contactos y seguimiento. Ahora recibe solicitudes más calificadas y transmite mayor confianza.",
  },
];

function makePreview(text, limit = 150) {
  if (!text) return "";
  if (text.length <= limit) return text;
  const sliced = text.slice(0, limit);
  const lastSpace = sliced.lastIndexOf(" ");
  return (lastSpace > 80 ? sliced.slice(0, lastSpace) : sliced).trim() + "…";
}

export default function CasosExito() {
  const previews = useMemo(() => CASES.map((c) => makePreview(c.text, 160)), []);
  const [open, setOpen] = useState(() => CASES.map(() => false));

  const toggle = (idx) => {
    setOpen((prev) => prev.map((v, i) => (i === idx ? !v : v)));
  };

  return (
    <section className="ovit-casos" id="casos-exito">
      <div className="ovit-casos__container">
        <header className="ovit-casos__header">
          <h2 className="ovit-casos__title">
            Casos <span>Éxito</span>
          </h2>

          <p className="ovit-casos__subtitle">
            Cientos de clientes nos recomiendan. Conoce cómo nuestras soluciones digitales han
            ayudado a negocios a verse más profesionales, captar más prospectos y convertir más ventas.
          </p>
        </header>

        <div className="ovit-casos__grid">
          {CASES.map((c, idx) => (
            <article
              key={c.name}
              className={`ovit-caso ${c.featured ? "ovit-caso--featured" : ""}`}
            >
              <h3>{c.name}</h3>
              <p className="ovit-caso__role">{c.role}</p>

              {/* Texto (colapsado / expandido) */}
              <div className={`ovit-caso__textWrap ${open[idx] ? "is-open" : ""}`}>
                <p className="ovit-caso__text">{open[idx] ? c.text : previews[idx]}</p>
              </div>

              {/* Botón */}
              <button
                type="button"
                className="ovit-caso__more"
                onClick={() => toggle(idx)}
                aria-expanded={open[idx]}
              >
                {open[idx] ? "Ver menos" : "Leer más"} <span aria-hidden="true">→</span>
              </button>
            </article>
          ))}
        </div>

        <div className="ovit-casos__cta">
          <p>🚀 Ellos ya transformaron su negocio con una estrategia digital completa.</p>
          <h4>¡Tú también puedes hacerlo!</h4>

          <a href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20iniciar%20mi%20estrategia%20digital.%20Me%20gustar%C3%ADa%20recibir%20una%20propuesta." className="ovit-casos__btn">
            Quiero transformar mi negocio
          </a>
        </div>
      </div>
    </section>
  );
}
